<template>
  <div class="todo-work-approve">
    <div class="content">
      <vxe-table
        class='atb-table header-table edit-table'
        border='full'
        height='100%'
        auto-resize resizable
        :data="approveData"
        ref="approveTable"
        @cell-click="expandRow"
      >
        <vxe-table-column type='seq' width='55' align='center' title="序号"></vxe-table-column>
        <vxe-table-column v-if="noticeType !== 'addWork'" field='workPlanTitle' width='120' :title="workType === 'Month' ? '月' : '周'"></vxe-table-column>
        <vxe-table-column field="workClassify" title="工作项分类" width="120">
          <template #default="{ row }">{{ formatWorkClassify(row.workClassify) }}</template>
        </vxe-table-column>
        <vxe-table-column field="workItemContent" title="工作项目" width="120">
          <template #default="{row}">
            <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.workItemContent}}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="wholeTarget" title="总目标" min-width="160">
          <template #default="{row}">
            <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.wholeTarget}}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="weight" title="权重" width="50"></vxe-table-column>
        <vxe-table-column field="creationTime" title="创建时间" width="160">
          <template #default="{ row }">{{ row.creationTime? formatDate(new Date(row.creationTime), 'yyyy-MM-dd HH:mm:ss'):0 }}</template>
        </vxe-table-column>
        <vxe-table-column field="finishDate" title="完成时间" width="100">
          <template #default="{ row }">{{ formatDate(row.finishDate, 'yyyy-MM-dd') }}</template>
        </vxe-table-column>
        <vxe-table-column field="remark" title="备注" min-width="160">
          <template #default="{row}">
            <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.remark}}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="summary" title="总结" min-width="160">
          <template #default="{row}">
            <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{row.summary}}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column field="status" title="完成情况" width="100" show-overflow>
          <template #default="{ row }">
            {{ formatStatus(row.status) }}
          </template>
        </vxe-table-column>
        <vxe-table-column  title="发布人" width="80">{{sendName}}</vxe-table-column>
        <vxe-table-column field="resWkName" title="指定人" width="80"></vxe-table-column>
      </vxe-table>
    </div>
    <div class="form-wrap" v-if="noticeType != 'addWork'">
      <el-form :model="editForm" :rules="rules" ref="form" label-width='92px' class="atb-input" label-position="right">
        <el-form-item label="审批意见" prop="approveReason" label-width="80px">
          <el-input :readonly="!role" type="textarea" maxlength="500" v-model="editForm.approveReason"></el-input>
          <fast-approve v-if="role" @approveText="approveText"></fast-approve>
        </el-form-item>
      </el-form>
    </div>
    <div class="btn-wrap">
      <el-button v-if="role && role != 'revert' && noticeType != 'addWork'"
        type="passed" class="btn" @click="passed">通过</el-button>
      <el-button v-if="role && role != 'revert' && noticeType != 'addWork'"
        type="rejected" class="btn" @click="rejected">驳回</el-button>
      <el-button type="clear" class="btn" @click="$parent.$parent.hide()">关闭</el-button>
    </div>
  </div>
</template>
<script>
import XEUtils from 'xe-utils'
export default {
  name: 'TodoWorkApprove',
  props: {
    msgObjectId: {
      typeof: String,
      default: ''
    },
    role: {
      type: Number,
      default: 0
    },
    msgId: {
      type: String,
      default: ''
    },
    workType: {
      type: String,
      default: ''
    },
    msgObjectType: {
      type: String,
      default: ''
    },
    noticeType:{
      type:String,
      default:''
    },
    msgObjectChildId: {
      type: Array,
      default: () => ([])
    },
    sendName: {
      type: String,
      default: ''
    },
    sendAction: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      editForm: {
        approveReason: ''
      },
      approveData: [],
      workClassifyList: [],
      statusList: [],
    }
  },
  mounted() {
    this.getMonthWorkItemClassify();
    this.getWorkItemProcessStatusDict();
    this.getList();
  },
  methods: {
    expandRow({row, rowIndex}) {
      this.approveData[rowIndex].expandRowFlag = !this.approveData[rowIndex].expandRowFlag;
      this.$refs.approveTable.updateData(this.approveData);
    },
    // 工作项分类
    getMonthWorkItemClassify() {
      this.$ajax.get(this.$api.common.getDict, {ItemType:'MonthWorkItemClassify'}).then(res=>{
        if(res.code === 0){
          this.workClassifyList = [];
          res.data && res.data.rows.forEach(t => {
            this.workClassifyList.push({label: t.itemDesc, value: parseInt(t.itemValue)});
          });
          this.workClassifyList.sort((a, b) => a.value - b.value)
        }
      });
    },
    // 状态
    getWorkItemProcessStatusDict() {
      this.$ajax.get(this.$api.common.getDict, { ItemType:'WorkItemProcessStatus' }).then(res=>{
        if(res.code === 0){
          res.data.rows.forEach(t=>{
            if (t.itemValue == 40) return 0;
            this.statusList.push({label: t.itemDesc, value: parseInt(t.itemValue)});
          });
          this.statusList.sort((a, b) => a.value - b.value)
        }
      });
    },
    formatWorkClassify(workClassify) {
      const searchItem = this.workClassifyList.find(item => item.value == workClassify);
      return searchItem ? searchItem.label : '';
    },
    formatStatus(status) {
      const statusItem = this.statusList.find(item => item.value == status)
      return statusItem ? statusItem.label : '';
    },
    formatDate(value, format) {
      if (value) {
        return XEUtils.toDateString(value, format)
      }
      return '';
    },
    approveText(e) {
      this.editForm.approveReason = e;
    },
    getList() {
      const params = {
        id: this.msgId,
      };
      if (this.noticeType === "addWork"){
        this.$ajax.get(this.$api.todoWork.getDetail, {id: this.msgObjectId, addMonthId: this.msgObjectChildId && this.msgObjectChildId.length > 0 ? this.msgObjectChildId[0] : undefined,}).then((res) => {
          this.approveData = [res.data] || [];
        });
      } else {
        this.$ajax.get(this.$api.todoWork.approveInfo, params).then((res) => {
          const todoWorkInfo = res.data ? res.data.todoWorkInfo : {};
          const workPlanItem = res.data ? res.data.workItemInfo : {};
          todoWorkInfo.workPlanTitle = workPlanItem.title;
          this.approveData = res.data ? [res.data.todoWorkInfo] : [];
  
          this.editForm.approveReason = this.role ? '' : todoWorkInfo.approveReason;
        });
      }
    },

    passed() {
      const rowItem = this.approveData[0] || {};
      const params = {
        msgObjectId: this.msgObjectId,
        msgObjectChildId: JSON.stringify(this.msgObjectChildId),
        updateReason: this.editForm.approveReason,
        updateStatus: '20',
        sendAction: this.sendAction,
        weight: rowItem.weight + '',
        msgId: this.msgId,
      };
      this.$ajax.post(this.$api.todoWork.updateStatus, params).then(res => {
        if (res.code === 0) {
          this.$refs.form.resetFields();
          this.$message.success('审批成功');
          this.$emit('submitSuccess');
          this.editForm = {};
          this.$parent.$parent.hide();
        }
      });
    },
    rejected() {
      const rowItem = this.approveData[0] || {};
      const params = {
        msgObjectId: this.msgObjectId,
        msgObjectChildId: JSON.stringify(this.msgObjectChildId),
        updateReason: this.editForm.approveReason,
        updateStatus: '30',
        sendAction: this.sendAction,
        weight: rowItem.weight + '',
        msgId: this.msgId,
      };
      if (typeof (params.updateReason) === "undefined" || params.updateReason === null || params.updateReason.split(" ").join("").length === 0 || params.updateReason.replace(/\s+/g, "").length === 0) {
        return this.$message.error("必须填写驳回原因");
      }
      this.$ajax.post(this.$api.todoWork.updateStatus, params).then(res => {
        if (res.code === 0) {
          this.$refs.form.resetFields();
          this.$message.success('审批成功');
          this.$emit('submitSuccess');
          this.editForm = {};
          this.$parent.$parent.hide();
        }
      });
    },
  },
}
</script>
<style scoped lang='scss'>
.todo-work-approve {
  .content {
    height: 260px;
  }

  .el-button.el-button--passed {
    color: #ffffff;
    background-color: #22b6a1;
    border-color: #22b6a1;
  }

  .el-button.el-button--rejected {
    background-color: #0dcc82;
    border-color: #0dcc82;
    color: #ffffff;
  }

  .el-button.el-button--clear {
    background-color: #F5BF2B;
    border-color: #F5BF2B;
    color: #ffffff;
  }

  .el-button {
    width: 110px;
    border-radius: 10px;
  }

  .btn-wrap {
    text-align: right;
    margin-top: 10px;
  }

  .form-wrap {
    margin: 10px 0px;

    .el-autocomplete {
      width: 100%;
    }

    .customerSelect {
      width: 100%;
    }
  }

  ::v-deep .header-table {
    table {
      height: 100%;
    }

    overflow: auto;
    flex-grow: 1;

    .vxe-table--header-wrapper {
      background-color: $--bg-color-complete !important;
    }

    .main-row {
      .vxe-body--column {
        padding: 0;
      }

      .vxe-cell {
        padding: 0;
      }
    }
  }

  .kpi-add {
    height: 48px;
    background-color: $--color-bg-table-header;
    color: $--color-primary;
    font-size: 14px;
    margin-top: -1px;
    padding: 0 15px;

    span {
      cursor: pointer;
    }
  }

  .atb-input {
    .el-form-item {
      margin-right: 0px;
    }
  }
}
</style>